import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the menu types
type Menu = 'Temperature' | 'Accumulated Rain' | 'Air pressure' | 'Flood' | 'Early Warning' | 'Reported Incidents' | 'Satellites' | 'River Sensors' | 'Air Quality' | 'Wind'|'Rainfall'|'tides'|'None' ;

type MenuSelectContextType = {
  menu: Menu;
  setMenuSelect: (newMenuSelect: Menu) => void;
};

const MenuSelectContext = createContext<MenuSelectContextType | undefined>(undefined);

interface MenuSelectContextProps {
  children: ReactNode;
}

export const MenuSelectProvider: React.FC<MenuSelectContextProps> = ({ children }) => {
    const [menu, setMenuState] = useState<Menu>('None');
  
    const setMenuSelect = (newMenu: Menu) => {
        setMenuState(newMenu);
    };
  
    return (
      <MenuSelectContext.Provider value={{ menu, setMenuSelect }}>
        {children}
      </MenuSelectContext.Provider>
    );
};

export const useMenu = () => {
    const context = useContext(MenuSelectContext);
    if (!context) {
      throw new Error('useLayout must be used within a LayoutProvider');
    }
    return context;
};